import {
  _PROCESS_ERROR, FORM_RESULT_GET, FORM_RESULT_GET_MANY,
  FORM_RESULT_MARK_PROCESSED, FORM_RESULT_CREATE_PLAT_CUST, FORM_RESULT_VWCONFIRM_SIGNUP,
} from './actions.types'
import {
  FORM_RESULT_SET_RESULT,
  FORM_RESULT_SET_RESULTS,
  FORM_RESULT_RESET_RESULT,
  FORM_RESULT_RESET_RESULTS,
  SIGNUP_SET_CHECKING_STATUS,
} from './mutations.types'
import FormResultService from '../services/form-result.service'
import SignupService from '../services/signup.service'

const initialState = {
  formResult: {
    rowkey: null,
    created_at: null,
    created_by: null,
    updated_at: null,
    updated_by: null,
    is_deleted: null,
    form_type: null,
    form: null,
    fk_parent_key: null,
    fk_organization_key: null,
    fk_account_key: null,
    payload: {},
  },
  formResultsFilter: {
    is_processed: '-1',
    search: '',
  },
  formResultsSortBy: '',
  formResultsSortDesc: false,
  formResultsPageSize: 12,
  formResults: [],
}

export const state = { ...initialState }

export const actions = {
  async [FORM_RESULT_GET] ({ dispatch, commit, rootState }, payload) {
    try {
      // console.log('logging in with: ', payload)
      const response = await FormResultService.get(payload)
      console.log('FormResult response: ', response.data)
      commit(FORM_RESULT_SET_RESULT, response.data)
      return response.data
    } catch (e) {
      throw await dispatch(_PROCESS_ERROR, e)
    }
  },
  async [FORM_RESULT_GET_MANY] ({ dispatch, commit, rootState }, payload) {
    try {
      // console.log('logging in with: ', payload)
      const response = await FormResultService.getMany('', payload)
      console.log('Login response: ', response.data)
      commit(FORM_RESULT_SET_RESULTS, response.data)
      return response.data
    } catch (e) {
      throw await dispatch(_PROCESS_ERROR, e)
    }
  },
  /***
   * Mark a form as processed status of a form-result
   * @param context
   * @param {string} payload.rowkey
   * @param {boolean} payload.is_processed
   * @returns {Promise<void>}
   */
  async [FORM_RESULT_MARK_PROCESSED] ({ dispatch, commit, rootState }, payload) {
    try {
      const { data } = await FormResultService.markProcessed(`${payload.rowkey}`)
      console.log('Updated form result:', data)
      commit(FORM_RESULT_SET_RESULT, data)
      return data
    } catch (error) {
      await dispatch(_PROCESS_ERROR, error)
      console.log(error)
      return []
    }
  },
  /***
   * Create a plat customer from a form-signup submission
   * @param context
   * @param {string} payload.rowkey
   * @param {boolean} payload.is_processed
   * @returns {Promise<void>}
   */
  async [FORM_RESULT_CREATE_PLAT_CUST] ({ dispatch, commit, rootState }, payload) {
    try {
      const { data } = await FormResultService.createPlatCustomer(payload)
      console.log('Returned Plat customer details', data)
      return data
    } catch (error) {
      await dispatch(_PROCESS_ERROR, error)
      console.log(error)
      return []
    }
  },
  /***
   * Confirm a VW signup form submission
   * @param {string} params.rowkey rowkey of the form to process
   * @returns {*}
   */
  async [FORM_RESULT_VWCONFIRM_SIGNUP] ({ dispatch, commit, rootState }, params) {
    try {
      commit(SIGNUP_SET_CHECKING_STATUS, true)
      console.log('Confirming vw signup: ', params)
      const response = await SignupService.vwConfirm(params.rowkey)
      console.log('Response: ', response.data)
      // commit(SIGNUP_RESET_SIGNUP)
      // router.push('/app')
      return response.data
    } catch (e) {
      commit(SIGNUP_SET_CHECKING_STATUS, false)
      throw await dispatch(_PROCESS_ERROR, e)
    }
  },

}

export const mutations = {
  [FORM_RESULT_RESET_RESULT] (state, data) {
    state.formResult = initialState.formResult
  },
  [FORM_RESULT_SET_RESULT] (state, data) {
    state.formResult = data
  },
  [FORM_RESULT_SET_RESULTS] (state, data) {
    state.formResults = data
  },
  [FORM_RESULT_RESET_RESULTS] (state) {
    state.formResults = []
  },
  SAVE_IS_PROCESSED (state, payload) {
    state.formResultsFilter.is_processed = payload
  },
  SAVE_SORT_DESC (state, payload) {
    state.formResultsSortDesc = payload
  },
  SAVE_FILTER_SEARCH (state, payload) {
    state.formResultsFilter.search = payload
  },
  SAVE_PAGE_SIZE (state, payload) {
    state.formResultsPageSize = payload
  },
  SAVE_FORMRESULTSSORTBY (state, payload) {
    state.formResultsSortBy = payload
  },

}
export const getters = {
  formResult: state => state.formResult,
  formResults: state => state.formResults,
  formResultsFilter: state => state.formResultsFilter,
  formResultsSortBy: state => state.formResultsSortBy,
  formResultsSortDesc: state => state.formResultsSortDesc,
  formResultsPageSize: state => state.formResultsPageSize,
}

export default {
  state,
  actions,
  mutations,
  getters,
}
